import React from 'react';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import fastWebLogo from '../../../../assets/images/nav-header.png';
import DrawerListItem from "./drawer-list-item/DrawerListItem";
import {useDrawerListStyles} from "./DrawerListStyles";
import {getDrawerListItems} from "./DrawerListHelper";
import {useDispatch, useSelector} from "react-redux";
import ExpandableDrawerListItem from "./expandable-drawer-list-item/ExpandableDrawerListItem";
import protect from "../../../../shared/utils/guard";
import {routePaths} from "../../../../shared/utils/constants/routePaths";
import * as actions from "../../../../store";

const DrawerList = () => {
    const classes = useDrawerListStyles();
    const showDigitalContract = useSelector((state) => state.authReducer.frontendConfiguration.newDigitalContract) === "1"
    const typeUser = useSelector((state) => state.authReducer.userClaims.typeUser)
    const isConsipCustomer = useSelector((state) => state.authReducer.userClaims.isConsipCustomer)
    const dispatch = useDispatch()

    const handleDrawerExternalClick = (e, li) => {
        e.stopPropagation();
        const externalHomePage = 'https://portaleaziende.fastweb.it'
        if (li.to === '/gestione-utenti') handleOpenNewTab(`${externalHomePage}/users`)
        if (li.to === '/home' || li.to === '/rete-fissa') handleOpenNewTab(`${externalHomePage}`)
    }

    const handleOpenNewTab = (url) => {
        const newTab = window.open(url, '_blank', 'noopener,noreferrer');
        if (newTab) newTab.opener = null
    };

    return (
        <List
            component="nav"
            subheader={
                <ListSubheader className={classes.navHeader} component="div">
                    <img className={classes.sidebarLogo} src={fastWebLogo} alt='FastWeb Logo'/>
                </ListSubheader>
            }
            className={classes.root}
        >
            {getDrawerListItems(typeUser, showDigitalContract, isConsipCustomer).map((li, idx) => (
                li.subItems ?
                    <ExpandableDrawerListItem key={"expandable-drawer-list-item-" + idx} to={li.to} text={li.text}
                                              icon={li.icon}>
                        {li.subItems.map((si, idx2) => {
                            const Hoc = protect(si.roles)(DrawerListItem);
                            return <Hoc key={"drawer-list-item-" + idx2}
                                        text={si.text}
                                        fontStyle="caption"
                                        onClick={si.to === routePaths.SIM ? () => dispatch(actions.setDashboardValue(true)) : () => {
                                        }}
                                        icon={si.icon}
                                        to={si.to}/>
                        })}
                    </ExpandableDrawerListItem> : <DrawerListItem key={"drawer-list-item-root-" + idx}
                                                                  {...li}
                                                                  onClick={(e) => handleDrawerExternalClick(e, li)}
                                                                  fontStyle="button"/>
            ))}
        </List>
    );
}

export default DrawerList;
